import ButtonComponent from "../components/button";
import FilterListComponent from "../components/filter-list";
import FilterRangeComponent from "../components/filter-range";
import FormComponent from "../components/form";
import LoaderColumnSvgComponent from "../components/loader-column-component";
import SpanComponent from "../components/span";
import {createInput} from "../create/create-input";
import {createLabel} from "../create/create-label";
import {createSpan} from "../create/create-span";
import {getItemsCount} from "../require/get-items-count";
import {getFilter} from "../utils/get-filter";
import {isEmptyArray} from "../utils/is-empty-array";
import {RenderPosition, render, replace} from "../utils/render";

const getOffset = (elem) => {
  const of2 = elem.parentElement.offsetTop;
  return of2 - elem.parentElement.parentElement.scrollTop + 62;
};


export default class FilterController {
  constructor({container, filterList, filter, onChangeData}) {
    this._container = container;
    this._filterList = filterList;
    this._filter = filter;
    this._onChangeData = onChangeData;
    this._openFilters = [];

    this._wrapComponent = null;
    this._showButton = null;
    this._applyButton = null;
    this._lastCheckedInputElement = null;

    this._onScrollPage = this._onScrollPage.bind(this);
    this._onChekboxFilterChangeHandler = this._onChekboxFilterChangeHandler.bind(this);
    this._onShowButtonClickHander = this._onShowButtonClickHander.bind(this);
    this._onApplyButtonClickHander = this._onApplyButtonClickHander.bind(this);
    this._onShowAllButtonClickHandler = this._onShowAllButtonClickHandler.bind(this);
    this._onFilterListChangeHandler = this._onFilterListChangeHandler.bind(this);
    this._onFilterRangeChangeHandler = this._onFilterRangeChangeHandler.bind(this);
  }

  render() {
    this._renderFilterItems(this._container);
    this._renderShowButton(this._container);
    this._renderApplyButton(this._container);

    // window.addEventListener(`scroll`, this._onScrollPage);
  }

  updateFilterList(filterList) {
    this._filterList = filterList;
    this._renderFilterItems(this._container);
  }

  clear() {
    this._setCountShowButton();
    this._showButton.getElement().dataset.show = `false`;
  }

  _renderCheckbox(divElement, filterItem, value) {
    const labelElement = createLabel(`filter__checkbox`);
    divElement.append(labelElement);

    const checkboxInputElement = createInput(`filter__checkboxInput`, `checkbox`);
    checkboxInputElement.dataset.alias = filterItem.alias;
    checkboxInputElement.dataset.id = value.value;
    checkboxInputElement.dataset.title = value.title;

    if (this._filter[filterItem.alias]) {
      checkboxInputElement.checked = this._filter[filterItem.alias].values
      .map((it) => it.id)
      .includes(String(value.value));
    }

    labelElement.append(checkboxInputElement);
    checkboxInputElement.addEventListener(`change`, this._onChekboxFilterChangeHandler);

    const titleSpanElement = createSpan(`filter__checkboxLabel`, value.title);
    labelElement.append(titleSpanElement);

    if (value.count) {
      const countSpanElement = createSpan(`filter__checkboxCount`, value.count);
      labelElement.append(countSpanElement);
    }
  }

  _renderFilterItems(container) {
    const oldComponent = this._wrapComponent;
    this._wrapComponent = new FormComponent({
      className: `filter__form`,
      isValidate: false,
    });

    Object.values(this._filterList)
    .forEach((filterItem) => {
      // const filterItem = this._filterList[itemId];

      if (filterItem.type === `lst`) {
        this._renderFilterListItem(this._wrapComponent.getElement(), filterItem);
      }

      if (filterItem.type === `rng`) {
        this._renderFilterRangeItem(this._wrapComponent.getElement(), filterItem);
      }
    });

    if (oldComponent) {
      replace(this._wrapComponent, oldComponent);
    } else {
      render(container, this._wrapComponent.getElement(), RenderPosition.BEFOREEND);
    }
  }

  _renderFilterListItem(container, filterData) {
    const values = filterData.values;

    if (this._filter[filterData.alias]) {
      Object.values(values).forEach((value) => {
        value.isCheck = this._filter[filterData.alias].values.map((it) => it.id).includes(String(value.value));
      });
    }

    const component = new FilterListComponent({
      title: filterData.title,
      alias: filterData.alias,
      values: filterData.values,
      isShowAll: this._openFilters.includes(filterData.alias)
    });

    component.setShowAllButtonClickHandler(this._onShowAllButtonClickHandler);

    component.setCheckboxChangeHandler(this._onFilterListChangeHandler);

    render(container, component.getElement(), RenderPosition.BEFOREEND);
  }

  _getCheckboxValues(filterItem) {
    if (typeof filterItem.values[`n`] === `undefined`) {
      return {};
    }

    const values = {
      0: {
        value: `n`,
        title: filterItem.values[`n`],
        count: 0
      }
    };

    if (this._filter[filterItem.alias] && this._filter[filterItem.alias].values) {
      Object.values(values).forEach((value) => {
        value.isCheck = this._filter[filterItem.alias].values.map((it) => it.id).includes(String(value.value));
      });
    }

    return values;
  }

  _getStep(min, max) {
    const isInt = Number.isInteger(min) && Number.isInteger(max);
    if (!isInt || max - min < 10) {
      return `1`;
    }

    return `10`;
  }

  _renderFilterRangeItem(container, filterItem) {
    const minValue = filterItem.values.min * 10;
    const maxValue = filterItem.values.max * 10;

    let startValue = this._filter && this._filter[filterItem.alias] && this._filter[filterItem.alias].min ? +this._filter[filterItem.alias].min * 10 : +minValue;
    let finishValue = this._filter && this._filter[filterItem.alias] && this._filter[filterItem.alias].max ? +this._filter[filterItem.alias].max * 10 : +maxValue;

    const checkboxValues = this._getCheckboxValues(filterItem);

    const rangeComponent = new FilterRangeComponent({
      title: filterItem.title,
      alias: filterItem.alias,
      minValue,
      maxValue,
      startValue,
      finishValue,
      step: this._getStep(+filterItem.values.min, +filterItem.values.max),
      checkboxValues,
    });

    rangeComponent.onRangeChangeHandler(this._onFilterRangeChangeHandler);

    render(container, rangeComponent.getElement(), RenderPosition.BEFOREEND);
  }

  _renderShowButton(container) {
    this._showButton = new ButtonComponent({
      className: `button-primary filter__showButton`,
      title: `Показать`,
    });

    const svgComponent = new LoaderColumnSvgComponent();
    render(this._showButton.getElement(), svgComponent.getElement(), RenderPosition.BEFOREEND);

    const countComponent = new SpanComponent({});
    render(this._showButton.getElement(), countComponent.getElement(), RenderPosition.BEFOREEND);

    this._showButton.getElement().dataset.state = `loader`;

    this._showButton.setClickHandler(this._onShowButtonClickHander);

    render(container, this._showButton.getElement(), RenderPosition.BEFOREEND);
  }

  _renderApplyButton(container) {
    this._applyButton = new ButtonComponent({
      className: `button-primary filter__applyButton`,
      title: `Показать`,
    });

    this._applyButton.setClickHandler(this._onApplyButtonClickHander);

    render(container, this._applyButton.getElement(), RenderPosition.BEFOREEND);
  }

  _moveShowButton(offset) {
    this._showButton.getElement().dataset.show = `true`;
    this._showButton.getElement().style.transform = `translateY(${offset}px)`;
  }

  _setCountShowButton(count = ``) {
    this._showButton.getElement().dataset.state = `count`;
    this._showButton.getElement().querySelector(`span`).innerHTML = String(count);
    this._applyButton.getElement().innerHTML = `Показать ${String(count)}`;
  }

  _onScrollPage(evt) {
    const scroll = evt.target.scrollingElement.scrollTop;
    if (scroll >= 200) {
      this._container.classList.add(`filter--scroll`);
    } else {
      this._container.classList.remove(`filter--scroll`);
    }
  }

  _onChekboxFilterChangeHandler(evt) {
    const checkboxInputElement = evt.target;
    const isCheck = checkboxInputElement.checked;
    const alias = checkboxInputElement.dataset.alias;
    const id = checkboxInputElement.dataset.id;
    const title = checkboxInputElement.dataset.title;

    if (isCheck) {
      const newValue = {id, title};

      if (alias in this._filter) {
        this._filter[alias].values.push(newValue);
      } else {
        this._filter[alias] = {
          type: `list`,
          values: [newValue]
        };
      }
    } else {
      if (alias in this._filter) {
        const index = this._filter[alias].values.findIndex((it) => it.id === id);

        if (index !== -1) {
          this._filter[alias].values.splice(index, 1);
        }

        if (isEmptyArray(this._filter[alias])) {
          delete this._filter[alias];
        }
      }
    }

    this._lastCheckedInputElement = checkboxInputElement;
    this._moveShowButton(getOffset(checkboxInputElement));

    this._getItemsData();
    // setActivePage(1);
    // getItems();
    // setFilterUrl();
  }

  _getItemsData() {
    this._showButton.getElement().dataset.state = `loader`;

    getItemsCount({
      filter: getFilter(this._filter),
      resolveHandler: (response) => {
        this._setCountShowButton(+response.count);
      }
    });
  }

  _onShowButtonClickHander() {
    this._showButton.getElement().dataset.show = `false`;
    this._onChangeData(this._filter);
    this._lastCheckedInputElement = null;

  }

  _onApplyButtonClickHander() {
    this._showButton.getElement().dataset.show = `false`;
    this._onChangeData(this._filter);
  }

  _onShowAllButtonClickHandler(alias) {
    this._openFilters.push(alias);

    if (this._lastCheckedInputElement) {
      this._moveShowButton(getOffset(this._lastCheckedInputElement));
    }
  }

  _onFilterListChangeHandler(data, checkboxInputElement) {
    if (isEmptyArray(data.values)) {
      delete this._filter[data.alias];
    } else {
      this._filter[data.alias] = {
        type: `list`,
        title: data.title,
        values: data.values,
      };
    }

    this._lastCheckedInputElement = checkboxInputElement;
    this._moveShowButton(getOffset(checkboxInputElement));

    this._getItemsData();
    // setActivePage(1);
    // getItems();
    // setFilterUrl();
  }

  _onFilterRangeChangeHandler({alias, title, min, max, values}, startInputElement) {
    if (!min && !max && isEmptyArray(values)) {
      delete this._filter[alias];
    } else {
      this._filter[alias] = {
        type: `range`,
        title,
        min,
        max,
        values,
      };
    }

    this._lastCheckedInputElement = startInputElement;

    this._moveShowButton(getOffset(startInputElement));
    this._getItemsData();
  }
}
